import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import * as S from '../../../styles';
export const SmallNavigationTab = memo(function SmallNavigationTab(props) {
    const { label, icon, onClick, selected, width, data_tooltip } = props;
    return (_jsxs(S.SmallNavigationTab, { onClick: onClick, selected: selected, width: width, "data-tooltip": data_tooltip, children: [_jsx(S.TabIcon, { children: icon }), _jsx(S.TabLabel, { label: label, lineHeight: 1, fontSize: "0.8rem", fontWeight: "500", textAlign: "center", children: label })] }));
});
